(function () {
  function initScrollDots(root) {
    var track = root.querySelector('[data-ws-scroll-track]');
    var dots = root.querySelectorAll('[data-ws-scroll-dot]');
    if (!track || !dots.length) return;

    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;

    var dotsWrap = root.querySelector('[data-ws-scroll-dots-wrap]');

    // Some sections (e.g. WS Project Showcase, WS Create Gallery) keep the
    // same scroll track across every breakpoint but change how many items
    // fit per row via admin settings — so whether there's actually anything
    // to scroll to can only be known at runtime, not baked into the markup.
    function updateDotsVisibility() {
      if (!dotsWrap) return;
      var canScroll = track.scrollWidth > track.clientWidth + 1;
      dotsWrap.hidden = !canScroll;
    }

    function scrollToItem(item) {
      var trackRect = track.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var delta = itemRect.left - trackRect.left;
      track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
    }

    function updateActive() {
      var trackRect = track.getBoundingClientRect();
      var closestIndex = 0;
      var closestDistance = Infinity;

      // Items snap to the start (left edge) of the track, not the center,
      // so the "active" item is whichever one sits closest to the track's
      // left edge — matching scroll-snap-align: start below.
      items.forEach(function (item, index) {
        var itemRect = item.getBoundingClientRect();
        var distance = Math.abs(itemRect.left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var item = items[index];
        if (item) scrollToItem(item);
      });
    });

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateActive();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      updateActive();
      updateDotsVisibility();
    });
    updateActive();
    updateDotsVisibility();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ws-scroll-dots]').forEach(initScrollDots);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
